const fillServerErrors = require('../../../common/components/servererrorfiller');
const RECAPTCHA_V2 = window.config.RECAPTCHA_V2;
/**
	 * @component SelfexclusionFormDirective
	 * @version 1.1
	 *
	 * This directive is used for self exclusion.
	 *
	 * Usage:
	 		<wow-selfexclusion-form></wow-selfexclusion-form>
*
**/
module.exports = function (globalHeaderPanelService, breakpointsService, $state, $timeout, $q, selfexclusionService, googleCaptchaService, settingsService, ringCaptchaService) {
    return {
        restrict: 'E',
        template: require('./selfexclusion-form-template.html').trim(),
        scope: {},
        link(scope, elem) {
            scope.hideAll = false;
            scope.loadingRingCaptcha = false;
            scope.loadingSubmit = false;
            //scope.showMobilePhoneError = false;
            //Selfexclusion user detail request mapping object.
            scope.excludeDetails = {
                FirstName: null,
                LastName: null,
                EmailAddress: $state.params.email || null,
                MobilePhone: null,
                FourDigitCode: null,
                RingcaptchaToken: null
            };
            scope.showReCaptcha = false;
            scope.showReCaptchaError = false;
            scope.showReCaptchaErrorMessage = 'Please check the captcha';
            scope.ringCaptchaSent = false;
            scope.googleRecaptchaResponse = '';
            scope.recaptchaV2Key = RECAPTCHA_V2;
            scope.showGeneralError = false;
            scope.showGeneralErrorMessage = '';

            settingsService.getSettingValue('GoogleReCaptcha', 'EnableGoogleReCaptchaNew').then(function (response) {
                scope.showReCaptcha = response;
                if (scope.showReCaptcha) {
                    googleCaptchaService.loadReCaptcha();
                }
            });

            window.checkedCaptcha = function () {
                scope.showReCaptchaError = false;
            };

            window.recaptchaExpired = function () {
                scope.showReCaptchaError = true;
            };

            scope.clearErrors = function () {
                fillServerErrors.clearForm(scope.excludeForm, scope);
                scope.showGeneralError = false;
                scope.showGeneralErrorMessage = '';
                scope.showReCaptchaError = false;
            };

            scope.ringhCaptchaSubmit = function () {
                scope.clearErrors();
                if (!scope.excludeForm.MobilePhone.$valid) {
                    scope.excludeForm.MobilePhone.$touched = true;
                    return;
                }

                if (scope.showReCaptcha) {
                    scope.googleRecaptchaResponse = window.grecaptcha ? window.grecaptcha.getResponse() : '';
                    if (!scope.googleRecaptchaResponse) {
                        scope.showReCaptchaError = true;
                        return;
                    }
                }
                scope.ringcaptchaSendCode();
            };

            scope.ringcaptchaSendCode = function () {
                scope.loadingRingCaptcha = true;
                ringCaptchaService.code(scope.excludeDetails.MobilePhone, scope.showReCaptcha, scope.googleRecaptchaResponse)
                    .then((response) => {
                        if (response.Success) {
                            ringCaptchaService.token = response.Token;
                            scope.ringCaptchaSent = true;
                        } else { //error
                            const fieldErrors = {};
                            fieldErrors.MobilePhone = 'Please try again later';
                            fillServerErrors.fillForm(scope.excludeForm, fieldErrors, scope);
                            scope.selfexclusionValidationErrors = fieldErrors;

                            ringCaptchaService.token = '';
                            scope.ringCaptchaSent = false;
                            if (window.grecaptcha) {
                                window.grecaptcha.reset();
                            }
                        }
                    })
                    .finally(() => {
                        scope.loadingRingCaptcha = false;
                    });
            };

            scope.delay = function (milliseconds) {
                const defer = $q.defer();
                $timeout(() => {
                        defer.resolve('');
                }, milliseconds);

                return defer.promise;
            };

            scope.submitSelfExclusion = function () {
                if (!scope.excludeForm.$valid) {
                    return false;
                }

                //Check righcaptcha token
                if (!ringCaptchaService.token) {
                    scope.showGeneralError = true;
                    scope.showGeneralErrorMessage = 'Please click to generate 4 digit sms code';
                    return false;
                }

                if (scope.showReCaptchaError) {
                    return false;
                }

                scope.clearErrors();

                scope.loadingSubmit = true;
                scope.excludeDetails.RingcaptchaToken = ringCaptchaService.token;
                scope.selfexclusionValidationMessage = null;

                selfexclusionService.save(scope.excludeDetails).then(function (res) {
                    scope.loadingSubmit = false;
                    if (res.Success) {
                        selfexclusionService.submitForm(scope.excludeDetails).then(function (response) {
                            if (response.status === 200 && !(!!response.data && !!response.data.error)) {
                                scope.hideAll = true;
                                scope.delay(300).then(() => {
                                    $state.go('shop.inspiration.selfexclusion.confirm');
                                });
                            } else {
                                $state.go('shop.inspiration.selfexclusion.error');
                            }
                        });
                    } else {
                        if (res.ErrorMessage === 'ERROR_INVALID_PIN_CODE') {
                            const fieldErrors = {};
                            fieldErrors.FourDigitCode = 'Invalid four digit code';
                            fillServerErrors.fillForm(scope.excludeForm, fieldErrors, scope);
                            scope.selfexclusionValidationErrors = fieldErrors;
                        } else {
                            $state.go('shop.inspiration.selfexclusion.error');
                        }
                    }
                });

            };

            // ------------------- Analytics --------------------- //

            // check when the form become dirty for the first time
            // send an event to analytics service
            const atmFormWatcher = scope.$watch('excludeDetails', () => {
                if (scope.excludeForm.$dirty) {
                    selfexclusionService.registrationStart();
                    atmFormWatcher(); // remove the watcher
                }
            }, true);

            // get the last dirty field and save it for atmRegistrationAbandoned
            elem.find('.input').on('focus', (data) => {
                if (data && data.currentTarget && data.currentTarget.id) {
                    scope.lastFocusedField = data.currentTarget.id;
                }
            });

            //  check when this directive is destroyed and fire an event to analytics
            scope.$on('$destroy', () => {
                selfexclusionService.registrationAbandoned(scope.lastFocusedField);
            });
        }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/selfexclusion/selfexclusion-form-directive.js
 **/